/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';
import PartnerAccountDetailAppData from './PartnerAccountDetailAppData';

/**
 * The PartnerControllerDtoPartnerAccountDetailResponse model module.
 * @module model/PartnerControllerDtoPartnerAccountDetailResponse
 * @version 1.0
 */
class PartnerControllerDtoPartnerAccountDetailResponse {
    /**
     * Constructs a new <code>PartnerControllerDtoPartnerAccountDetailResponse</code>.
     * @alias module:model/PartnerControllerDtoPartnerAccountDetailResponse
     */
    constructor() { 
        
        PartnerControllerDtoPartnerAccountDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PartnerControllerDtoPartnerAccountDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PartnerControllerDtoPartnerAccountDetailResponse} obj Optional instance to populate.
     * @return {module:model/PartnerControllerDtoPartnerAccountDetailResponse} The populated <code>PartnerControllerDtoPartnerAccountDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PartnerControllerDtoPartnerAccountDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('appList')) {
                obj['appList'] = ApiClient.convertToType(data['appList'], [PartnerAccountDetailAppData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PartnerControllerDtoPartnerAccountDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PartnerControllerDtoPartnerAccountDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        if (data['appList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['appList'])) {
                throw new Error("Expected the field `appList` to be an array in the JSON data but got " + data['appList']);
            }
            // validate the optional field `appList` (array)
            for (const item of data['appList']) {
                PartnerAccountDetailAppData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} accountNo
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['email'] = undefined;

/**
 * @member {Array.<module:model/PartnerAccountDetailAppData>} appList
 */
PartnerControllerDtoPartnerAccountDetailResponse.prototype['appList'] = undefined;






export default PartnerControllerDtoPartnerAccountDetailResponse;

